import { useNavigate } from 'react-router-dom';
import { useConfigContext } from '../contexts/config-context';
import { useCallback } from 'react';

const normalizePath = (path: string) => path.replace(/^\/+|\/+$/g, '');

const getFullPath = (path: string, baseRoute: string) => {
	const base = normalizePath(baseRoute || '');
	const target = normalizePath(path || '');

	if (!base) return `/${target}`;
	if (target.startsWith(base)) return `/${target}`;
	return `/${base}/${target}`;
};

const useAINavigation = () => {
	const { baseRoute } = useConfigContext();

	const navigate = useNavigate();

	const navigateTo = useCallback(
		(path: string, options = {}) => {
			navigate(getFullPath(path, baseRoute), options);
		},
		[getFullPath, navigate, baseRoute],
	);

	return { navigateTo, getFullPath };
};

export default useAINavigation;
